import React from "react";
import { InfoCard } from "@dtsl/react/dist/components/InfoCard";
import { IconComponent } from "@dtsl/react";
import PropTypes from "prop-types";
import { messageError, prettyPrintJSON, provideErrorContentForValidator } from "./helper";
import styles from "./jsonViewer.module.less";
import classNames from "classnames";
function JsonValidator(_ref) {
  let {
    data,
    validatorContainerClassName,
    getValidationErrorContent,
    errorColumnClassName
  } = _ref;
  const parsedData = React.useMemo(() => prettyPrintJSON(data), [data]);
  const validatorContainerClasses = classNames({
    [styles["validator-container"]]: true,
    [validatorContainerClassName]: !!validatorContainerClassName
  });
  const errorColumnClasses = classNames({
    [styles["error-column"]]: true,
    [errorColumnClassName]: !!errorColumnClassName
  });
  const addLineNumbers = (code, error) => {
    const errorInfo = messageError(error);
    const {
      line: lineNum,
      column: columnNum
    } = errorInfo;
    const lines = code.split("\n");
    return lines.map((line, index) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: index === lineNum - 1 ? styles["line-number-error"] : styles["line-number"]
    }, index + 1), index === lineNum - 1 ? /*#__PURE__*/React.createElement("span", {
      key: line,
      className: styles["error-line"]
    }, line.substring(0, columnNum - 1), /*#__PURE__*/React.createElement("span", {
      className: errorColumnClasses
    }, line[columnNum - 1]), line.substring(columnNum), /*#__PURE__*/React.createElement("span", {
      className: styles["error-icon-container"]
    }, /*#__PURE__*/React.createElement(IconComponent, {
      size: 16,
      value: "Error",
      className: styles["error-icon"]
    }))) : line, "\n"));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, parsedData?.error && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles["error-message"]
  }, /*#__PURE__*/React.createElement(InfoCard, {
    variant: "error",
    content: getValidationErrorContent(messageError(parsedData?.error)),
    className: styles["info-card-error"]
  })), /*#__PURE__*/React.createElement("div", {
    className: validatorContainerClasses
  }, /*#__PURE__*/React.createElement("pre", {
    className: styles["code-container"]
  }, /*#__PURE__*/React.createElement("code", null, addLineNumbers(parsedData?.data, parsedData?.error))))));
}
JsonValidator.defaultProps = {
  data: `{}`,
  getValidationErrorContent: provideErrorContentForValidator
};
JsonValidator.propTypes = {
  data: PropTypes.object,
  getValidationErrorContent: PropTypes.func,
  validatorContainerClassName: PropTypes.object,
  errorColumnClassName: PropTypes.object
};
export { JsonValidator };